module.exports = __webpack_public_path__ + "img/tamu.4b71cb3e.png";